export enum UserFlow {
  BULK_PAYMENT_PERMANENT = 'BULK_PAYMENT_PERMANENT',
  BULK_PAYMENT_TEMPORARY = 'BULK_PAYMENT_TEMPORARY',
  CREDENTIALS_ADD = 'CREDENTIALS_ADD',
  CREDENTIALS_AUTHENTICATE = 'CREDENTIALS_AUTHENTICATE',
  CREDENTIALS_REFRESH = 'CREDENTIALS_REFRESH',
  PAYMENT_TEMPORARY = 'PAYMENT_TEMPORARY',
  PAYMENT_PERMANENT = 'PAYMENT_PERMANENT',
  CONNECT_ACCOUNTS = 'CONNECT_ACCOUNTS',
  UPDATE_CONSENT = 'UPDATE_CONSENT',
  AUTHORIZE_CONSENT = 'AUTHORIZE_CONSENT',
  CREATE_REPORT = 'CREATE_REPORT',
  UNKNOWN = 'UNKNOWN',
}

export const detectUserFlow = (url: string) => {
  const { pathname, search } = new URL(url);

  if (pathname.includes('/pay') && pathname.includes('bulk')) {
    if (pathname.includes('credentials') || search?.includes('authorization_code')) {
      return UserFlow.BULK_PAYMENT_PERMANENT;
    }

    return UserFlow.BULK_PAYMENT_TEMPORARY;
  }

  if (pathname.includes('/pay') && pathname.includes('vrp-mandate')) {
    return UserFlow.AUTHORIZE_CONSENT;
  }

  if (pathname.includes('/pay')) {
    if (pathname.includes('credentials') || search?.includes('authorization_code')) {
      return UserFlow.PAYMENT_PERMANENT;
    }

    return UserFlow.PAYMENT_TEMPORARY;
  }

  if (pathname.includes('authorize')) {
    return UserFlow.CREDENTIALS_ADD;
  }

  if (pathname.includes('credentials') && pathname.includes('add')) {
    return UserFlow.CREDENTIALS_ADD;
  }

  if (pathname.includes('credentials') && pathname.includes('refresh')) {
    return UserFlow.CREDENTIALS_REFRESH;
  }

  if (pathname.includes('credentials') && pathname.includes('authenticate')) {
    return UserFlow.CREDENTIALS_AUTHENTICATE;
  }

  if (pathname.includes('transactions') && pathname.includes('connect-accounts')) {
    return UserFlow.CONNECT_ACCOUNTS;
  }

  if (pathname.includes('transactions') && pathname.includes('update-consent')) {
    return UserFlow.UPDATE_CONSENT;
  }

  if (pathname.includes('account-check') && pathname.includes('create-report')) {
    return UserFlow.CONNECT_ACCOUNTS;
  }

  if (pathname.includes('account-check') && pathname.includes('update-consent')) {
    return UserFlow.UPDATE_CONSENT;
  }

  if (pathname.includes('products') && pathname.includes('connect-accounts')) {
    return UserFlow.CONNECT_ACCOUNTS;
  }

  if (pathname.includes('reports') && pathname.includes('create-report')) {
    return UserFlow.CREATE_REPORT;
  }

  if (pathname.includes('risk-insights') && pathname.includes('create-report')) {
    return UserFlow.CREATE_REPORT;
  }

  if (pathname.includes('expense-check') && pathname.includes('create-report')) {
    return UserFlow.CREATE_REPORT;
  }

  if (pathname.includes('income-check') && pathname.includes('create-report')) {
    return UserFlow.CREATE_REPORT;
  }

  return UserFlow.UNKNOWN;
};
